import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setShowErrors } from "../Errorsxx/errorsSlice";
import QueryString from "qs";
import { signOut } from "../authSlice/authSlice";
import { authApiSlice } from "../authSlice/authApiSlice";
import { reset } from "../MenuSlice/menuSlice";
import { resetConsult } from "../consultSlice/consultSlice";
import { resetCustomFilters } from "../trackingSlice/trackingSlice";
import { shootToast } from "codekit";

const fullLogOut = async (api) => {
  await api.dispatch(authApiSlice.endpoints.logout.initiate());
  api.dispatch(signOut());
  api.dispatch(reset());
  api.dispatch(resetConsult());
  api.dispatch(resetCustomFilters());
};

const prepareQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_GENIO_ENDPOINT,
  mode: "cors",
  timeout: process.env.REACT_APP_CIMA_TIMEOUT,
  prepareHeaders: (Headers, { getState }) => {
    const token = getState().persistedReducer.tokenGenio;
    Headers.set("Accept", "application/json");
    if (token) {
      Headers.set("Authorization", `Bearer ${token}`);
    }
    return Headers;
  },
  paramsSerializer: (params) => {
    return QueryString.stringify(params);
  },
});

export const baseQueryWithLogOut = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  let autoHide = true;
  let text = "";
  let variant = "";

  const statusCode = result?.error?.status;

  switch (statusCode) {
    case "TIMEOUT_ERROR":
      text = "No se pudo conectar con la plataforma. Por favor, intenta de nuevo más tarde.";
      variant = "error";
      break;
    case 401:
      text = "Tu sesión en GENIO ha expirado. Por favor, inicia sesión nuevamente.";
      variant = "error";
      await fullLogOut(api);
      break;
    case 403:
    case 405:
    case 422:
    case 500:
      const errors = result?.error?.data;
      if (errors?.message) {
        text = errors?.message;
      } else if (errors.errors) {
        const errorObject = errors.errors;
        const errorsProperties = Object.getOwnPropertyNames(errorObject);
        errorsProperties.forEach((property) => {
          if (property !== "exception") {
            text +=
              errorObject[property] !== "Invalid Query"
                ? errorObject[property]
                : "Se presentaron problemas en la consulta";
            text += "\n";
          } else {
            text += errorObject[property].includes("Duplicate entry")
              ? "La informacion que intenta guardar ya existe"
              : errorObject[property];
          }
        });
      } else {
        text = "Error no identificado";
      }
      variant = "error";
      break;
    case 413:
      text = "Lo sentimos el tamaño de la solicitud excede el límite permitido. Intenta de nuevo con menos información.";
      variant = "error";
      break;
    default:
      break;
  }

  if (text !== "") {
    shootToast({
      variant,
      text,
      duration: 5000,
      autoHide,
    });
  }

  return result;
};

export const baseQuery = async (args, api, extraOptions) => {
  let result = await prepareQuery(args, api, extraOptions);
  switch (result?.error?.status) {
    case 422:
    case 500:
      api.dispatch(setShowErrors(true));
      break;
    default:
      break;
  }
  return result;
};
